import React from "react";
import { FaTimes, FaPalette, FaPlay } from "react-icons/fa";

const CreationOptionsModal = ({ isOpen, onClose, options, selectedLabel, onSelect }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-50 glass-effect rounded-3xl border border-white/20 bg-[#0a0a0a]/95 backdrop-blur-3xl p-6 sm:p-8 w-[90vw] max-w-6xl max-h-[85vh] overflow-y-auto shadow-2xl flex flex-col">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 rounded-xl bg-gradient-to-r from-pink-500/20 to-purple-500/20 border border-pink-300/20">
            <FaPlay className="text-pink-300 text-lg" />
          </div>
          <div className="text-xl font-semibold text-white tracking-tight">Bring an image to life</div>
          <button
            type="button"
            className="ml-auto p-2 rounded-xl text-gray-400 hover:text-white hover:bg-white/10 transition-all duration-200"
            title="Close"
            onClick={onClose}
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {options.map(opt => (
            <button
              key={opt.id || opt.label}
              type="button"
              onClick={() => onSelect(opt.label)}
              className={`group relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl ${
                selectedLabel === opt.label
                  ? 'ring-2 ring-pink-400 ring-offset-2 ring-offset-[#0a0a0a] shadow-lg shadow-pink-400/25'
                  : 'hover:ring-1 hover:ring-white/30'
              }`}
              title={opt.label}
            >
              <div className="aspect-square relative">
                {opt.img ? (
                  <img src={opt.img} alt={opt.label} className="w-full h-full object-cover" loading="lazy" />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-white/5 to-white/0" />
                )}

                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

                <div className="absolute bottom-8 left-3 right-3 text-center">
                  <div className="text-white font-bold text-sm sm:text-base leading-tight drop-shadow-lg">
                    {opt.label}
                  </div>
                </div>

                {/* <div className="absolute bottom-2 left-2 right-2">
                  <div className="text-white/90 text-xs leading-tight drop-shadow-md line-clamp-2 text-center">
                    {opt.desc || 'Use this mode to tailor the editor behavior for your workflow.'}
                  </div>
                </div> */}

                {selectedLabel === opt.label && (
                  <div className="absolute top-2 right-2 w-6 h-6 bg-pink-400 rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                  </div>
                )}

                <div className="absolute inset-0 bg-white/0 group-hover:bg-white/5 transition-colors duration-200" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreationOptionsModal; 